"use strict";

function initProductTrims() {
    const $trims = $('.product-trims');
    if (!$trims.length) return;

    const sliderEl = $('.product-info__slider .swiper')[0];
    let suppressSlideActivation = false;

    function activateColor($btn, slide = true) {
        $trims.find('.product-trims__color').removeClass('is-active');
        $btn.addClass('is-active');

        if (slide) {
            const index = parseInt($btn.data('slide-index'), 10);
            if (!sliderEl || index < 0) return;
            const swiper = sliderEl.swiper;
            if (!swiper) return;
            suppressSlideActivation = true;
            swiper.slideToLoop(index, 300);
        }
    }

    function activateTrim($tab, slideToFirst = true) {
        $trims.find('.product-trims__tab').removeClass('is-active').attr('aria-selected', 'false');
        $trims.find('.product-trims__colors').removeClass('is-active');

        $tab.addClass('is-active').attr('aria-selected', 'true');
        const $colors = $tab.find('.product-trims__colors').addClass('is-active');

        if (slideToFirst) {
            activateColor($colors.find('.product-trims__color').first());
        }
    }

    $trims.on('click', '.product-trims__tab-header', function () {
        activateTrim($(this).closest('.product-trims__tab'));
    });

    $trims.on('click', '.product-trims__color', function (e) {
        e.stopPropagation();
        activateColor($(this));
    });

    // Listen for Swiper slide changes to sync trim/color state
    if (sliderEl) {
        const waitForSwiper = setInterval(() => {
            const swiper = sliderEl.swiper;
            if (!swiper) return;
            clearInterval(waitForSwiper);
            swiper.autoplay.stop();

            swiper.on('slideChange', function () {
                if (suppressSlideActivation) {
                    suppressSlideActivation = false;
                    return;
                }
                const realIndex = swiper.realIndex;
                const $matchedColor = $trims.find(`.product-trims__color[data-slide-index="${realIndex}"]`);
                if (!$matchedColor.length) return;

                const $parentTab = $matchedColor.closest('.product-trims__tab');
                if (!$parentTab.hasClass('is-active')) {
                    activateTrim($parentTab, false);
                }
                activateColor($matchedColor, false);
            });
        }, 50);
    }
}

export default function init() {
    if (!$('.product-info__slider').length) return;
    initProductTrims();
}
